import axios from "axios";
import { API_CONFIG } from "../constants";

export async function registerUserWithoutGoogle(requestBody: {
  email: string;
}) {
  return (await axios.post(`${API_CONFIG.URL}/loginWithoutGoogle`, requestBody))
    .data;
}
